import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { PatientDocumentsModel } from 'src/app/models/PatientDocumentsModel';
import { PatientDocumentsService } from 'src/app/services/PatientDocumentsService';
import { ImageTypesModel, RadTypeModel } from 'src/app/models/Masterdata.Model';
import { masterdataService } from 'src/app/services/MasterdataService';
import swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { URLsConfig } from 'src/app/URLsConfig';
import { PathologyModel } from 'src/app/models/PathologyModel';
import { PathologyService } from 'src/app/services/PathologyService';
import { ExaminationService } from 'src/app/services/ExaminationService';


@Component({
  selector: 'app-patient-documents-edit',
  templateUrl: './patient-documents-edit.component.html',
  styleUrls: ['./patient-documents-edit.component.css']
})
export class PatientDocumentsEditComponent implements OnInit {
  id = 0 ;
  documenttype ='';
  patientcode = '' ;
  patientname = '';
  doccode = '' ;
  docname = '' ;
  docdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  doctype = '' ;
  doctype_file = '';
  pathimage = '' ;
  pathimage_1 = '' ;
  fileBytes :any;
  docnotes = '';
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  compcode = '1' ;
  File_Name = '';
  imageList: ImageTypesModel[] = [];
  pathologyList : PathologyModel[]=[];


  wornningmessage_Saved = '';
  doctime = formatDate(new Date(), 'HH:mm', 'en');

  myimage :any;
  sellersPermitString = '';
  sellersPermitFile: any;
  imageSrc: any;
  imageSource: any;
  @Output() submitClicked = new EventEmitter<any>();

  file1 : File| null ;

  constructor(public storage: LocalStorageService,
              public masterdataservice : masterdataService,
              public patientdocuments: PatientDocumentsModel,
              public pathologyservice : PathologyService,
              public examinationservice : ExaminationService,
              public masterdataService : masterdataService,
              public urlsconfig: URLsConfig,
              public patientdocumentsservice : PatientDocumentsService,
              public dialogRef: MatDialogRef<PatientDocumentsEditComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
                this.patientcode =   data.patientcode,
                this.doccode=    data.doccode,
                this.id=    data.docid,
                this.docname=  data.docname,
                this.doctype= data.doctype,
                this.docdate=data.docdate,
                this.docnotes = data.docnotes,
                this.pathimage= data.pathimage,
                this.fileBytes = data.fileBytes ,
                this.pathimage_1= data.pathimage_1,
                this.fileBytes = data.fileBytes,
                this.documenttype = data.documenttype

    }

  ngOnInit(): void {
    this.retrivePathologyLookupTop();
   if (this.doctype == 'PDF'){ this.doctype_file = 'application/pdf'};
   if (this.doctype == 'Image'){ this.doctype_file = 'image/jpeg'};

   this.pathimage =this.urlsconfig.StaticFilepath + this.pathimage;

   const url = new URL(this.pathimage);
   const file_name = url.pathname.split('/').pop();

   const file3 = new File([this.pathimage],
    file_name,  {type: this.doctype_file});


    this.file1 =file3;
    this.fileBytes = 'Ex';
  }
  retriveImagesLookupTop() {
    this.imageList = [];
    this.masterdataservice.getmasterCLookupTopImages().subscribe((data: ImageTypesModel[]) => {
      for (let i = 0; i < data.length; i++) {
         this.imageList[i] = data[i];
      }

    })
  }
  retrivePathologyLookupTop() {
  if(this.documenttype == 'Clinical imaging'){
    this.masterdataservice.getmasterCLookupTopImages().subscribe((data: ImageTypesModel[]) => {
      for (let i = 0; i < data.length; i++) {
         this.imageList[i] = data[i];
      }
    })
    }
    if(this.documenttype == 'Pathology'){
      this.pathologyservice.getPathologyCLookupTop('1').subscribe((data1: PathologyModel[]) => {
        this.imageList = [];
        for (let i = 0; i < data1.length; i++) {
          this.pathologyList[i] = data1[i];
           this.imageList.push({
          imageid : this.pathologyList[i].pathTypeCode,
          imagename : this.pathologyList[i].pathTypeName,
          notes : this.pathologyList[i].pathTypeNotes,
          userid : 'sa',
          modifieddate : null,
          })
        }
      });
    }
    if(this.documenttype == 'Laboratory'){
      this.examinationservice.getExamTypeLookup('1').subscribe((data1: PathologyModel[]) => {
        this.imageList = [];
        for (let i = 0; i < data1.length; i++) {
          this.pathologyList[i] = data1[i];
           this.imageList.push({
          imageid : this.pathologyList[i].pathTypeCode,
          imagename : this.pathologyList[i].pathTypeName,
          notes : this.pathologyList[i].pathTypeNotes,
          userid : 'sa',
          modifieddate : null,
          })
        }
      });
    }
    if(this.documenttype == 'Treatment'){
      this.examinationservice.getExamTypeLookup('').subscribe((data1: PathologyModel[]) => {
        this.imageList = [];
        for (let i = 0; i < data1.length; i++) {
          this.pathologyList[i] = data1[i];
           this.imageList.push({
          imageid : this.pathologyList[i].pathTypeCode,
          imagename : this.pathologyList[i].pathTypeName,
          notes : this.pathologyList[i].pathTypeNotes,
          userid : 'sa',
          modifieddate : null,
          })
        }
      });
    }

    if(this.documenttype == 'Radiotherapy'){
      this.masterdataService.getRadTypeLookupTopGov().subscribe((data1: RadTypeModel[]) => {
          this.imageList = [];
          for (let i = 0; i < data1.length; i++) {

            // this.pathologyList[i].pathTypeCode = data1[i].radtypecode;
            // this.pathologyList[i].pathTypeName = data1[i].radtypename;
            // this.pathologyList[i].pathTypeNotes = data1[i].radtypenotes;


            this.imageList.push({
           imageid :data1[i].radtypecode,
           imagename : data1[i].radtypename,
           notes : data1[i].radtypenotes,
           userid : 'sa',
           modifieddate : null,
            })
          }
        });
      }
  }

  Change_Image(){
    if(this.doctype == 'Image'){this.pathimage_1 = this.pathimage};
    if(this.doctype == 'PDF'){this.pathimage_1 = '../assets/Documents/pdf.jpg' }
    if(this.doctype == 'Excel'){this.pathimage_1 = '../assets/Documents/excel.jpg' }
    if(this.doctype == 'Word'){this.pathimage_1 = '../assets/Documents/Word.jpg' }
    if(this.doctype == 'Image'){this.pathimage_1 = '../assets/Documents/Image.jpg' }

  }
  public picked(event: any) {

    let fileList: FileList = event.target.files;
    const filePath: File = event.target.files[0];
    this.fileBytes = 'New';
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.file1 = fileList[0];
      this.pathimage = '../assets/Documents/' + file.name;
      if(this.doctype == 'Image'){this.pathimage_1 = this.pathimage};
      if(this.doctype == 'PDF'){this.pathimage_1 = '../assets/Documents/pdf.jpg' }
      if(this.doctype == 'Excel'){this.pathimage_1 = '../assets/Documents/excel.jpg' }
      if(this.doctype == 'Word'){this.pathimage_1 = '../assets/Documents/Word.jpg' }

    }
    else {
      alert("No file selected");
    }
  }
  Save_Date(){
    const str1 = formatDate(this.docdate, 'yyyy-MM-dd', 'en') + 'T' +this.doctime +':00.000Z';

    this.patientdocuments.patientcode = this.patientcode;
    this.patientdocuments.id = 0;
    this.patientdocuments.doccode = this.doccode.toString();
    if(this.docname != null || this.docname !='') {this.patientdocuments.docname = this.docname}else {this.patientdocuments.docname = ''};
    this.patientdocuments.doctype = this.doctype;

    this.patientdocuments.docdate = formatDate(this.docdate, 'yyyy-MM-dd', 'en');
    this.patientdocuments.docnotes = this.docnotes;
    this.patientdocuments.documenttype = this.documenttype;
    this.patientdocuments.doctime = str1;

    this.patientdocuments.fileimage = this.file1;
    this.patientdocuments.fileBytes = this.fileBytes;

    this.patientdocuments.userid = this.storage.retrieve('stguserId');
    this.patientdocuments.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.patientdocuments.compcode = this.compcode;
    // console.log("patientdocuments",this.patientdocuments)
    this.patientdocumentsservice.AddPatientDocuments(this.patientdocuments).subscribe(data => {

    this.mesgSave();
    this.dialogRef.close();
    },
      error => { alert(error); }
    );
  }
  async copyFile() {

}
  mesgSave() {
    if (this.storage.retrieve('stgLanguage') == 'E') {
      this.wornningmessage_Saved = 'Your work has been saved';

    }
    if (this.storage.retrieve('stgLanguage') == 'A') {
      this.wornningmessage_Saved = 'تم خفظ المستند بنجاح.';
    }
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.DeleteLine();
        swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  DeleteLine(){

    this.patientdocumentsservice.DelPatientDocumentsLine(this.patientcode,this.doccode.toString(), this.compcode).subscribe(
      (data: PatientDocumentsModel) => {
        this.dialogRef.close();
      }
    );

  }
  CloseEdit(){
    this.dialogRef.close();
  }

}
